<template>
    <div id="error-wrapper">
        <div id="error-img-wrapper">
            <div id="error-img" class="sprite error-cc" />
        </div>
        <div id="error-title">{{ errorTitle }}</div>
        <div id="error-text">{{ errorText }}</div>
        <div id="error-code">Error code {{ errorCodeWithDefault }}</div>
    </div>
</template>

<script>
    import errorCodes from "../assets/json/error-codes.json";
    import axios from "axios";
    import { mapState, mapMutations } from "vuex";
    import routeHelper from "../router/route-helper";
    import { appSettings } from "../mixins/app-settings";

    export default {
        name: "Error",
        mixins: [ appSettings ],
        props: {
            errorCode: String
        },
        errorCodes: errorCodes,
        computed: {
            ...mapState({
                session: state => state.session
            }),
            errorCodeWithDefault() {
                if (this.errorCode === undefined) {
                    return "1000";
                }

                return this.errorCode;
            },
            errorTitle() {
                return this.$options.errorCodes
                    .find(e => e.errorCode === this.errorCodeWithDefault).title;
            },
            errorText() {
                return this.$options.errorCodes
                    .find(e => e.errorCode === this.errorCodeWithDefault).text;
            }
        },
        methods: {            
            ...mapMutations([
                "setCustomization"
            ])
        },
        async mounted() {
            if (this.session.check !== null) {
                let requestBody =
                {
                    SiteId: this.session.siteId,
                    AccountId: this.session.accountId,
                    CheckId: this.session.checkId
                };

                await axios
                    .post(this.apiBaseUrl + "/check/unlock", requestBody)
                    .then(response => {
                        if (response) {
                            console.log("Check unlocked.");
                        }
                    })
                    .catch(error => {
                        if (error.response &&
                            error.response.data &&
                            error.response.data.errorMessage) {
                            console.error("Unable to unlock check: " + error.response.data.errorMessage);
                        }
                        else {
                            console.error(error);
                        }
                    })
            }

            // There's a need to refetch the customization data because preventNavigatingAway()
            // call below causes the session data to reset. 
            if (this.session.appName == undefined) {
                await axios.get(this.getApiBaseUrl() + "/app/customizationsettings")
                .then(response => {
                    const settings = response.data;                    

                    // Save to session so other views can display customized values.
                    this.setCustomization({
                        appName: settings.appName,
                        appIcon: settings.appIcon
                    });
                })
                .catch(error => {
                    console.error(error);
                });
            }
            
            routeHelper.preventNavigatingAway();
        }
    }
</script>

<style scoped>
    #error-wrapper {
        margin: 0 auto;
        max-width: 250px;
    }

    #error-img-wrapper {
        padding-left: 10px;
    }

    #error-img {
        margin: 40px auto;
    }

    #error-title {
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 20px;
    }

    #error-text {
        margin-bottom: 80px;
    }

    #error-code {
        color: #bbbbbb;
        font-size: 12px;
    }
</style>